import styled from "styled-components";

export const HealthList = styled.ul`
  gap: 32px;
  width: calc(100vw - 32px);
  display: flex;
  overflow-y: auto;
  flex-direction: column;
`;

export const HealthItem = styled.li`
  gap: 12px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const HealthItemTit = styled.div`
  width: 100%;
  color: ${(props) => props.theme.colors.black100};
  display: flex;
  font-size: 1.6rem;
  font-weight: 700;
  align-items: center;
  justify-content: space-between;
`;

export const HealthItemNote = styled.div`
  gap: 10px;
  display: flex;
  flex-direction: column;

  span {
    color: ${(props) => props.theme.colors.black70};
    font-size: 1.2rem;
    padding-left: 10px;
  }
`;

export const HealthInfoBtn = styled.div`
  top: 50%;
  left: 50%;
  display: flex;
  position: absolute;
  transform: translate(-50%, -50%);
  align-items: center;
  flex-direction: column;
`;
